module.exports = require("./fr-PM.js");